var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceFour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 157,
    viewBox: "0 0 145 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_243_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.189 52.2353C136.189 84.6901 109.731 111 77.0943 111C44.4574 111 18 84.6901 18 52.2353C18 19.7804 62.026 3 94.6629 3C127.3 3 136.189 19.7804 136.189 52.2353Z",
    fill: "#F9EEEE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.645 53.6759C107.046 52.1272 107.857 50.0622 107.857 47.8498C107.857 42.9824 103.875 39 99.0074 39C94.1401 39 90.1576 42.9824 90.1576 47.8498C90.1576 50.0622 90.9689 52.1272 92.3701 53.6759C90.0101 55.0771 88.1664 57.1421 87.0602 59.5758C86.1015 58.5433 84.9953 57.5846 83.7415 56.9208C85.1428 55.3721 85.954 53.3072 85.954 51.0947C85.954 46.2273 81.9716 42.2449 77.1042 42.2449C72.2368 42.2449 68.2544 46.2273 68.2544 51.0947C68.2544 53.3072 69.0656 55.3721 70.4668 56.9208C69.2131 57.6583 68.1069 58.5433 67.1482 59.5758C66.042 57.0683 64.1245 55.0034 61.8383 53.6759C63.2395 52.1272 64.0507 50.0622 64.0507 47.8498C64.0507 42.9824 60.0683 39 55.2009 39C50.3336 39 46.3511 42.9824 46.3511 47.8498C46.3511 50.0622 47.1624 52.1272 48.5636 53.6759C44.6549 55.9621 42 60.1658 42 65.0332V70.1955C42 70.933 42.59 71.523 43.3275 71.523H63.8295V73.3667C63.8295 74.1042 64.4195 74.6942 65.157 74.6942H88.8302C89.5677 74.6942 90.1576 74.1042 90.1576 73.3667V71.523H110.66C111.397 71.523 111.987 70.933 111.987 70.1955V65.0332C112.208 60.1658 109.553 55.9621 105.645 53.6759ZM99.0074 41.6549C102.4 41.6549 105.202 44.3836 105.202 47.8498C105.202 51.316 102.474 54.0447 99.0074 54.0447C95.615 54.0447 92.8126 51.316 92.8126 47.8498C92.8126 44.3836 95.615 41.6549 99.0074 41.6549ZM77.1779 44.8261C80.5704 44.8261 83.3728 47.5548 83.3728 51.021C83.3728 54.4871 80.6441 57.2158 77.1779 57.2158C73.7118 57.2158 70.9831 54.4871 70.9831 51.021C70.9831 47.5548 73.7855 44.8261 77.1779 44.8261ZM55.3484 41.6549C58.7409 41.6549 61.5433 44.3836 61.5433 47.8498C61.5433 51.316 58.8146 54.0447 55.3484 54.0447C51.8823 54.0447 49.1536 51.1685 49.1536 47.776C49.1536 44.3836 51.956 41.6549 55.3484 41.6549ZM44.8024 68.8681V65.0332C44.8024 60.8295 47.3099 57.1421 50.9235 55.5196C52.1773 56.2571 53.726 56.6996 55.2747 56.6996C56.8972 56.6996 58.3721 56.2571 59.6258 55.5196C62.4283 56.7733 64.567 59.2808 65.3782 62.3045C64.4932 64.0744 63.9032 66.1394 63.9032 68.2781V68.9418H44.8024V68.8681ZM87.6502 72.0392H66.7057V68.2043C66.7057 64.0007 69.2131 60.3133 72.8268 58.6908C74.0805 59.4283 75.6292 59.8708 77.1779 59.8708C78.8004 59.8708 80.2754 59.4283 81.5291 58.6908C85.1428 60.3133 87.6502 64.0007 87.6502 68.2043V72.0392ZM109.553 68.8681H90.3789V68.2043C90.3789 66.0656 89.8627 64.0744 88.9039 62.2307C89.7152 59.207 91.8539 56.6996 94.6563 55.4459C95.91 56.1834 97.4587 56.6258 99.0074 56.6258C100.63 56.6258 102.105 56.1834 103.359 55.4459C106.972 57.1421 109.48 60.7558 109.48 64.9594V68.8681H109.553Z",
    fill: "#FF3833"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_243_4421",
    x: 0,
    y: 0,
    width: 144.188,
    height: 157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_243_4421"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_243_4421",
    result: "effect2_dropShadow_243_4421"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_243_4421",
    result: "effect3_dropShadow_243_4421"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_243_4421",
    result: "effect4_dropShadow_243_4421"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_243_4421",
    result: "effect5_dropShadow_243_4421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_243_4421",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceFour);
export default __webpack_public_path__ + "static/media/serviceFour.113ee60a862de042632683f56e67b0c5.svg";
export { ForwardRef as ReactComponent };